import React from 'react'
import QueueAnim from 'rc-queue-anim'
import { Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import fireb from '../../../firebase/fireBase'

const logOut = () => {
  fireb.auth().signOut()
    .then(result => {
      localStorage.clear()
      window.location.assign("/")
    })
    .catch(error => {
      console.error(error)
    })
}

const AdminError = () => {
  return (
    <div className="page-err">
      <QueueAnim type="bottom" className="ui-animate">
        <div key="1">
          <div className="err-container text-center">
            <br />
            <br />
            <h2>
              <FormattedMessage
                id="error.handler.title"
                defaultMessage="Sorry! Something went wrong."
              />
            </h2>
            <div className="err-code-container">
              <div className="err-code" >
                <img src="/assets/images/error.svg" width="30%" alt="Bug located!" />
              </div>
            </div>
            <br />
            <h3>
            <FormattedMessage
                id="error.handler.title"
                defaultMessage="By the way: ¡Congratulations you are a bug hunter! 
                Our team is working to fix this asap."
              />
            </h3>
            <br />
            <br />
            <Button
              type="primary"
              size="large"
              onClick={logOut}
            >
              <FormattedMessage
                id="error.handler.button"
                defaultMessage="Please Sign In Again"
              />
            </Button>
          </div>
        </div>
      </QueueAnim>
    </div >
  )
}

export default AdminError
